/**
 * @owner @Appboy/sms
 */

import type { MessagingService } from "@lib/messageComposition/types";

type KoMessagingServiceFields = {
  rcsEnabled?: boolean;
};

/**
 * Reads RCS-enabled from API snake_case (`rcs_enabled`) or live Knockout instances (`rcsEnabled`).
 */
export const isRcsEnabled = (ms: MessagingService | undefined | null): boolean => {
  return ms?.rcs_enabled ?? (ms as MessagingService & KoMessagingServiceFields)?.rcsEnabled ?? false;
};
